module.exports = __webpack_public_path__ + "media/images/sponsors/sponsor-04@2x-16e840ac07e870fbe2d930fa863fc691.png";